<div class="radio-group" [class.radio-group--small]="radios?.length <= 2">
  <ng-content></ng-content>
</div>
